// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WalletRouteImport } from './routes/wallet'
import { Route as ValidateRouteImport } from './routes/validate'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as ResaleRouteImport } from './routes/resale'
import { Route as RequestOrganizerAccessRouteImport } from './routes/request-organizer-access'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as MyTicketsRouteImport } from './routes/my-tickets'
import { Route as LoginRouteImport } from './routes/login'
import { Route as CreateEventRouteImport } from './routes/create-event'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard.index'
import { Route as SettingsPayoutsRouteImport } from './routes/settings.payouts'
import { Route as EventsEventIdRouteImport } from './routes/events.$eventId'
import { Route as EditEventEventIdRouteImport } from './routes/edit-event.$eventId'
import { Route as DevSeatStressRouteImport } from './routes/dev.seat-stress'
import { Route as DashboardAdminRouteImport } from './routes/dashboard.admin'
import { Route as CheckoutReturnRouteImport } from './routes/checkout.return'
import { Route as CheckoutSessionIdRouteImport } from './routes/checkout.$sessionId'
import { Route as AuthMfaVerifyRouteImport } from './routes/auth.mfa-verify'
import { Route as AuthMfaSetupRouteImport } from './routes/auth.mfa-setup'
import { Route as AdminUsersRouteImport } from './routes/admin.users'
import { Route as AdminTenantsRouteImport } from './routes/admin.tenants'
import { Route as AdminSettlementsRouteImport } from './routes/admin.settlements'
import { Route as AdminResaleRouteImport } from './routes/admin.resale'
import { Route as AdminRefundsRouteImport } from './routes/admin.refunds'
import { Route as AdminPayoutsRouteImport } from './routes/admin.payouts'
import { Route as AdminOnvoHealthRouteImport } from './routes/admin.onvo-health'
import { Route as AdminHealthRouteImport } from './routes/admin.health'
import { Route as DashboardVenuesIndexRouteImport } from './routes/dashboard.venues.index'
import { Route as DashboardVenuesNewRouteImport } from './routes/dashboard.venues.new'
import { Route as DashboardVenuesVenueIdRouteImport } from './routes/dashboard.venues.$venueId'
import { Route as DashboardHelpVenuesRouteImport } from './routes/dashboard.help.venues'
import { Route as AdminTenantsTenantIdRouteImport } from './routes/admin.tenants.$tenantId'
import { Route as AdminPayoutsUsersRouteImport } from './routes/admin.payouts.users'
import { Route as DashboardEventsEventIdVenueRouteImport } from './routes/dashboard.events.$eventId.venue'
import { Route as DashboardEventsEventIdValidationsRouteImport } from './routes/dashboard.events.$eventId.validations'
import { Route as DashboardEventsEventIdStaffRouteImport } from './routes/dashboard.events.$eventId.staff'

const WalletRoute = WalletRouteImport.update({
            id: '/wallet',path: '/wallet',getParentRoute: () => rootRouteImport
          })
const ValidateRoute = ValidateRouteImport.update({
            id: '/validate',path: '/validate',getParentRoute: () => rootRouteImport
          })
const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const ResaleRoute = ResaleRouteImport.update({
            id: '/resale',path: '/resale',getParentRoute: () => rootRouteImport
          })
const RequestOrganizerAccessRoute = RequestOrganizerAccessRouteImport.update({
            id: '/request-organizer-access',path: '/request-organizer-access',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const MyTicketsRoute = MyTicketsRouteImport.update({
            id: '/my-tickets',path: '/my-tickets',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const CreateEventRoute = CreateEventRouteImport.update({
            id: '/create-event',path: '/create-event',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const DashboardIndexRoute = DashboardIndexRouteImport.update({
            id: '/dashboard/',path: '/dashboard/',getParentRoute: () => rootRouteImport
          })
const SettingsPayoutsRoute = SettingsPayoutsRouteImport.update({
            id: '/settings/payouts',path: '/settings/payouts',getParentRoute: () => rootRouteImport
          })
const EventsEventIdRoute = EventsEventIdRouteImport.update({
            id: '/events/$eventId',path: '/events/$eventId',getParentRoute: () => rootRouteImport
          })
const EditEventEventIdRoute = EditEventEventIdRouteImport.update({
            id: '/edit-event/$eventId',path: '/edit-event/$eventId',getParentRoute: () => rootRouteImport
          })
const DevSeatStressRoute = DevSeatStressRouteImport.update({
            id: '/dev/seat-stress',path: '/dev/seat-stress',getParentRoute: () => rootRouteImport
          })
const DashboardAdminRoute = DashboardAdminRouteImport.update({
            id: '/dashboard/admin',path: '/dashboard/admin',getParentRoute: () => rootRouteImport
          })
const CheckoutReturnRoute = CheckoutReturnRouteImport.update({
            id: '/checkout/return',path: '/checkout/return',getParentRoute: () => rootRouteImport
          })
const CheckoutSessionIdRoute = CheckoutSessionIdRouteImport.update({
            id: '/checkout/$sessionId',path: '/checkout/$sessionId',getParentRoute: () => rootRouteImport
          })
const AuthMfaVerifyRoute = AuthMfaVerifyRouteImport.update({
            id: '/auth/mfa-verify',path: '/auth/mfa-verify',getParentRoute: () => rootRouteImport
          })
const AuthMfaSetupRoute = AuthMfaSetupRouteImport.update({
            id: '/auth/mfa-setup',path: '/auth/mfa-setup',getParentRoute: () => rootRouteImport
          })
const AdminUsersRoute = AdminUsersRouteImport.update({
            id: '/admin/users',path: '/admin/users',getParentRoute: () => rootRouteImport
          })
const AdminTenantsRoute = AdminTenantsRouteImport.update({
            id: '/admin/tenants',path: '/admin/tenants',getParentRoute: () => rootRouteImport
          })
const AdminSettlementsRoute = AdminSettlementsRouteImport.update({
            id: '/admin/settlements',path: '/admin/settlements',getParentRoute: () => rootRouteImport
          })
const AdminResaleRoute = AdminResaleRouteImport.update({
            id: '/admin/resale',path: '/admin/resale',getParentRoute: () => rootRouteImport
          })
const AdminRefundsRoute = AdminRefundsRouteImport.update({
            id: '/admin/refunds',path: '/admin/refunds',getParentRoute: () => rootRouteImport
          })
const AdminPayoutsRoute = AdminPayoutsRouteImport.update({
            id: '/admin/payouts',path: '/admin/payouts',getParentRoute: () => rootRouteImport
          })
const AdminOnvoHealthRoute = AdminOnvoHealthRouteImport.update({
            id: '/admin/onvo-health',path: '/admin/onvo-health',getParentRoute: () => rootRouteImport
          })
const AdminHealthRoute = AdminHealthRouteImport.update({
            id: '/admin/health',path: '/admin/health',getParentRoute: () => rootRouteImport
          })
const DashboardVenuesIndexRoute = DashboardVenuesIndexRouteImport.update({
            id: '/dashboard/venues/',path: '/dashboard/venues/',getParentRoute: () => rootRouteImport
          })
const DashboardVenuesNewRoute = DashboardVenuesNewRouteImport.update({
            id: '/dashboard/venues/new',path: '/dashboard/venues/new',getParentRoute: () => rootRouteImport
          })
const DashboardVenuesVenueIdRoute = DashboardVenuesVenueIdRouteImport.update({
            id: '/dashboard/venues/$venueId',path: '/dashboard/venues/$venueId',getParentRoute: () => rootRouteImport
          })
const DashboardHelpVenuesRoute = DashboardHelpVenuesRouteImport.update({
            id: '/dashboard/help/venues',path: '/dashboard/help/venues',getParentRoute: () => rootRouteImport
          })
const AdminTenantsTenantIdRoute = AdminTenantsTenantIdRouteImport.update({
            id: '/$tenantId',path: '/$tenantId',getParentRoute: () => AdminTenantsRoute
          })
const AdminPayoutsUsersRoute = AdminPayoutsUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AdminPayoutsRoute
          })
const DashboardEventsEventIdVenueRoute = DashboardEventsEventIdVenueRouteImport.update({
            id: '/dashboard/events/$eventId/venue',path: '/dashboard/events/$eventId/venue',getParentRoute: () => rootRouteImport
          })
const DashboardEventsEventIdValidationsRoute = DashboardEventsEventIdValidationsRouteImport.update({
            id: '/dashboard/events/$eventId/validations',path: '/dashboard/events/$eventId/validations',getParentRoute: () => rootRouteImport
          })
const DashboardEventsEventIdStaffRoute = DashboardEventsEventIdStaffRouteImport.update({
            id: '/dashboard/events/$eventId/staff',path: '/dashboard/events/$eventId/staff',getParentRoute: () => rootRouteImport
          })





const AdminPayoutsRouteChildren = {
  AdminPayoutsUsersRoute: AdminPayoutsUsersRoute
}

const AdminPayoutsRouteWithChildren = AdminPayoutsRoute._addFileChildren(AdminPayoutsRouteChildren)




const AdminTenantsRouteChildren = {
  AdminTenantsTenantIdRoute: AdminTenantsTenantIdRoute
}

const AdminTenantsRouteWithChildren = AdminTenantsRoute._addFileChildren(AdminTenantsRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,CookiesRoute: CookiesRoute,CreateEventRoute: CreateEventRoute,LoginRoute: LoginRoute,MyTicketsRoute: MyTicketsRoute,PrivacyRoute: PrivacyRoute,RequestOrganizerAccessRoute: RequestOrganizerAccessRoute,ResaleRoute: ResaleRoute,TermsRoute: TermsRoute,UnsubscribeRoute: UnsubscribeRoute,ValidateRoute: ValidateRoute,WalletRoute: WalletRoute,AdminHealthRoute: AdminHealthRoute,AdminOnvoHealthRoute: AdminOnvoHealthRoute,AdminPayoutsRoute: AdminPayoutsRouteWithChildren,AdminRefundsRoute: AdminRefundsRoute,AdminResaleRoute: AdminResaleRoute,AdminSettlementsRoute: AdminSettlementsRoute,AdminTenantsRoute: AdminTenantsRouteWithChildren,AdminUsersRoute: AdminUsersRoute,AuthMfaSetupRoute: AuthMfaSetupRoute,AuthMfaVerifyRoute: AuthMfaVerifyRoute,CheckoutSessionIdRoute: CheckoutSessionIdRoute,CheckoutReturnRoute: CheckoutReturnRoute,DashboardAdminRoute: DashboardAdminRoute,DevSeatStressRoute: DevSeatStressRoute,EditEventEventIdRoute: EditEventEventIdRoute,EventsEventIdRoute: EventsEventIdRoute,SettingsPayoutsRoute: SettingsPayoutsRoute,DashboardIndexRoute: DashboardIndexRoute,DashboardHelpVenuesRoute: DashboardHelpVenuesRoute,DashboardVenuesVenueIdRoute: DashboardVenuesVenueIdRoute,DashboardVenuesNewRoute: DashboardVenuesNewRoute,DashboardVenuesIndexRoute: DashboardVenuesIndexRoute,DashboardEventsEventIdStaffRoute: DashboardEventsEventIdStaffRoute,DashboardEventsEventIdValidationsRoute: DashboardEventsEventIdValidationsRoute,DashboardEventsEventIdVenueRoute: DashboardEventsEventIdVenueRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)